import { DateTime } from 'luxon';
import { generateSamples } from './data-sample.generator.mock';
import { GraphAsset } from '../../model/dto/asset.type';
import { randomNumber } from '../../util/number/random-number';
import { TSiteTimezone } from '../../model/dto/site.type';

export function generateAssetMock(
        start: DateTime = DateTime.now().minus({ day: 2 }),
        end: DateTime = DateTime.now().plus({ day: 1 }),
        name: string = 'test',
        color: string = '#A52A2A',
        id: string = randomNumber().toString(),
        dataSeriesId: string = randomNumber().toString(),
        portfolioId: string = randomNumber().toString(),
        siteId: string = randomNumber().toString(),
): GraphAsset {
    return {
        actual: generateSamples(start, DateTime.now(), 6),
        actualId: randomNumber().toString(),
        category: 'HEAT',
        color,
        name,
        portfolioId,
        predicted: generateSamples(start, end, 5),
        predictedId: randomNumber().toString(),
        siteId,
        timezone: 'Europe/Berlin' as TSiteTimezone,
        unit: 'MWH',
        id,
        dataSeriesId,
        type: 'GENERATION',
        lastModifiedAt: new Date().toISOString(),
        stack: 0,
    }
}
